import React from 'react';
import { motion } from 'framer-motion';

export default function Ecology() {
  return (
    <section id="ecology" data-testid="ecology-section" className="py-20 md:py-32 bg-sand relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-7"
          >
            <p className="overline text-muted mb-4">Our quiet promise</p>
            <h2 className="editorial-display text-pond text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              <em className="italic font-light">Para sa lupa,</em>
              <br />
              para sa komunidad.
            </h2>
            <p className="mt-6 text-charcoal/85 text-lg md:text-xl leading-relaxed max-w-2xl">
              Hindi lang ito fishing pond. Asana is a long-term ecological project rooted in
              Bulacan — supporting local guides, restoring native fish populations, at
              gradually growing into a full nature retreat that respects both heritage and habitat.
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6">
              {[
                ['Local guides', 'We employ and train Bulakeño guides — fair wage, full season.'],
                ['Pond stewardship', 'Regulated stocking, feeding cycles, at weekly water quality checks.'],
                ['Low-impact build', 'Phase 1 keeps mature trees intact. Future phases continue eco-first.'],
              ].map(([t, d]) => (
                <div key={t} className="border-t border-moss/30 pt-5">
                  <p className="overline text-pond mb-2">{t}</p>
                  <p className="text-sm text-muted leading-relaxed">{d}</p>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.9 }}
            className="lg:col-span-5"
          >
            <div className="relative rounded-[36px] overflow-hidden aspect-[4/5] shadow-[0_30px_80px_rgba(26,59,43,0.18)]">
              <img
                alt="Bamboo eco-retreat huts at Asana Bulacan"
                src="https://images.unsplash.com/photo-1776135933174-7465a18e98d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxiYW1ib28lMjBodXQlMjByZXNvcnQlMjBuYXR1cmV8ZW58MHx8fHwxNzgxMzI2OTkzfDA&ixlib=rb-4.1.0&q=85"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-pond/55 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 text-offwhite">
                <p className="overline text-sky mb-2">Phase 2 · Coming soon</p>
                <p className="font-display text-2xl md:text-3xl leading-snug">
                  Eco-cabanas, nature trails, at a deeper retreat — woven into the same land
                  we tend today.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
